import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import PatientProfile from './PatientProfile';

loadDOMComponent({
	selector: 'react-patient-profile',
	callback: ({ container }) => {
		const userId = container.getAttribute('userId');
		const showIdentifier = container.getAttribute('showIdentifier') !== null;
		const showVerifyInformation =
			container.getAttribute('showVerifyInformation') !== null;
		const showInsurance = container.getAttribute('showInsurance') !== null;
		const showPsychoQuestionnaire =
			container.getAttribute('showPsychoQuestionnaire') !== null;
		const showHealthCard = container.getAttribute('showHealthCard') !== null;

		const links = {
			documentation: container.getAttribute('linkDocumentation') || null,
			notes: container.getAttribute('linkOpenNotes') || null,
			events: container.getAttribute('linkOpenEvents') || null,
			questionnaire: container.getAttribute('linkQuestionnaire') || null,
			educationMaterials:
				container.getAttribute('linkEducationMaterials') || null,
			verifyInsurance: container.getAttribute('linkVerifyInsurace') || null,
			verifyAddress: container.getAttribute('linkVerifyAddress') || null,
			verifyRegisteringDoctors:
				container.getAttribute('linkVerifyRegisteringDoctors') || null,
			issueEprescription:
				container.getAttribute('linkIssueEprescription') || null,
			medicalRecords: container.getAttribute('linkMedicalRecords') || null,
			medicalRecordsVaccination:
				container.getAttribute('linkMedicalRecordsVaccination') || null,
			mouNumber: container.getAttribute('linkMouNumber') || null,
			contactPatient: container.getAttribute('linkContactPatient') || null,
			insuranceCardDetail:
				container.getAttribute('linkInsuranceCardDetail') || null,
		};

		ReactDOM.render(
			<AppContextProvider>
				<PatientProfile
					userId={userId}
					showIdentifier={showIdentifier}
					showVerifyInformation={showVerifyInformation}
					links={links}
					showInsurance={showInsurance}
					showPsychoQuestionnaire={showPsychoQuestionnaire}
					showHealthCard={showHealthCard}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
